'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    console.error(error)

    fetch('/api/logger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'nextjs_global_error',
        digest: error.digest,
        message: error.message,
        path: window.location.pathname,
        ts: new Date().toISOString(),
      }),
    }).catch(() => {})
  }, [error])

  return (
    <html lang="en">
      <body className="min-h-screen bg-background font-effra text-foreground antialiased">
        <div className="flex min-h-screen flex-col">
          <div className="grow @container">
            <div className="mx-auto w-full max-w-screen-2xl">
              <header className="flex w-full items-center justify-between bg-background px-5 py-3 @tablet:px-6 @tablet:py-4 @laptop:h-20 @laptop:gap-6 @laptop:p-6">
                <img
                  src="/assets/svg/guardian-logo.svg"
                  alt="GuardianWell"
                  className="h-[20px] w-[158px] object-contain object-left @laptop:h-[27px] @laptop:w-[214px]"
                />
              </header>
              <main>
                <div className="flex w-full flex-col items-center justify-center gap-3 px-5 py-10 text-center @tablet:px-8 @tablet:py-12 @laptop:px-11 @laptop:py-15">
                  <h1 className="heading-hero-regular">
                    Something went wrong.
                  </h1>
                  <p className="support-styles-intro-text-regular">
                    Oops, looks like something went wrong.
                  </p>
                </div>
              </main>
            </div>
          </div>
          <div className="@container">
            <footer className="w-full bg-hudson-navy-950">
              <div className="mx-auto max-w-screen-2xl">
                <div className="flex flex-col gap-8 px-5 py-7 @tablet:gap-6 @tablet:px-6 @tablet:pb-6 @tablet:pt-7">
                  <img
                    src="/assets/svg/guardian-well-footer-logo.svg"
                    alt="GuardianWell"
                    width={214}
                    height={27}
                    className="self-center @mobile:self-start"
                  />
                </div>
              </div>
            </footer>
          </div>
        </div>
      </body>
    </html>
  )
}
